// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-boiri{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-__slug-indexstyleGrid-grid-bjjgw{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-ssnxh{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-bpozz{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-tpzrs{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-bkavz{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-cazqv{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-dtpba{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-boiri",
	"grid": "pages-info-__slug-indexstyleGrid-grid-bjjgw",
	"col6": "pages-info-__slug-indexstyleGrid-col6-ssnxh",
	"col3": "pages-info-__slug-indexstyleGrid-col3-bpozz",
	"col4": "pages-info-__slug-indexstyleGrid-col4-tpzrs",
	"col9": "pages-info-__slug-indexstyleGrid-col9-bkavz",
	"col12": "pages-info-__slug-indexstyleGrid-col12-cazqv",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-dtpba"
};
module.exports = ___CSS_LOADER_EXPORT___;
